export default {
  "moduleTitle.address": "Cím",
  "moduleTitle.address_details": "Részletes cím",
  "moduleTitle.activity_details": "Tevékenység adatai",
  "moduleTitle.add_log": "Napló hozzáadása",
  "moduleTitle.award_level": "Award fokozat",
  "moduleTitle.adventurous_journey": "Kaland",
  "moduleTitle.already_assessed": "Már kiértékelt!",
  "moduleTitle.approved": "Jóváhagyva!",
  "moduleTitle.assessor_details": "Kiértékelő adatai",
  "moduleTitle.authorising_contact_license_holder": "Kapcsolattartó/Licenc birtokos engedélyezése",
  "moduleTitle.category_journey_details": "{category} kaland részletei",
  "moduleTitle.complete_report": "Jelentés kitöltése",
  "moduleTitle.completed_progress": "{finished} teljesítve / {total}",
  "moduleTitle.congratulation": "Gratulálunk!",
  "moduleTitle.confirming_email_address": "E-mail cím igazolása...",
  "moduleTitle.contact_details": "Kapcsolattartó adatai",
  "moduleTitle.edit_log": "Napló szerkesztése",
  "moduleTitle.event_journey": "{event} utazás",
  "moduleTitle.forgotten_password": "Elfelejtett jelszó",
  "moduleTitle.great_you_are_almost_there": "Adatvédelmi szabályzat",
  "moduleTitle.home_address": "Lakcím",
  "moduleTitle.journey_overview": "Utazás áttekintése",
  "moduleTitle.log_detail": "Napló adatai",
  "moduleTitle.login": "Bejelentkezés",
  "moduleTitle.new_activity": "Új tevékenység",
  "moduleTitle.new_event_journey": "Új {event} kaland",
  "moduleTitle.new_residential_project": "Új aranyfokozatú tartózkodási projekt",
  "moduleTitle.notRegistred": "Nem regisztrált?",
  "moduleTitle.nominated_award_leader_contact_details": "Programkoordinátor kapcsolattartó adatai",
  "moduleTitle.nominated_award_leader": "Programkoordinátor",
  "moduleTitle.organisation_address": "Szervezet címe",
  "moduleTitle.organisation_details": "Szervezet adatai",
  "moduleTitle.online_record_book_account": "Online Record Book fiók",
  "moduleTitle.page_not_found": "404 - Az oldal nem elérhető",
  "moduleTitle.personal_details": "Személyes adatok",
  "moduleTitle.preparation_and_training": "Felkészülés és gyakorlás",
  "moduleTitle.profile_guardian_consent": "Szülő/gyám beleegyezése",
  "moduleTitle.profile_questions": "Profilkérdések",
  "moduleTitle.registration_for_level": "Regisztráció a következő szintre",
  "moduleTitle.residential_project": "Aranyfokozatú tartózkodási projekt",
  "moduleTitle.residential_project_details": "Aranyfokozatú tartózkodási projekt részletek",
  "moduleTitle.reset_password": "Jelszó megváltoztatása",
  "moduleTitle.welcome_to_the_orb": "Üdvözöljük az Online Record Book (ORB) platformon",
  "moduleTitle.we_have_sent_you_an_email": "E-mailben elküldtük az aktiváláshoz szükséges linket.",
  "moduleTitle.your_registration_is_complete": "A regisztrációja sikeres",
  "formTitle.activity_details": "Tevékenység adatai",
  "formTitle.assessor_details": "Kiértékelő adatai",
  "formTitle.supervisors_details": "Felügyelő adatai",
  "formTitle.preparation_and_training_activities": "Felkészülés és gyakorlás tevékenységek",
  "formTitle.added_preparation_activities": "Felkészülés és gyakorlás tevékenységek hozzáadva",
  "label.add_picture": "Kép mérete legfeljebb 10 MB",
  "label.address_first_line": "Cím első sora",
  "label.address_second_line": "Cím második sora (opcionális)",
  "label.are_you_already_running_award": "Már működteti a programot?",
  "label.are_you_the_main_award_leader": "Ön a  programközpont vezető lídere vagy koordinátora?",
  "label.award_participant": "Program résztvevő",
  "label.award_leader": "Award líder",
  "label.birthdate": "Születési dátum",
  "label.category": "Kategória",
  "label.change_locale": "Helyszín módosítása",
  "label.choose_project": "Tevékenység kiválasztása",
  "label.city": "Város",
  "label.choose_as_major_activity": "Kiválasztás fő tevékenységként",
  "label.date": "Dátum",
  "label.date_of_birth": "Születési dátum",
  "label.description_of_progress": "Eredményeid leírása",
  "label.duration": "Időtartam (óra / perc)",
  "label.email": "E-mail",
  "label.email_address": "E-mail cím",
  "label.email_again": "E-mail igazolása",
  "label.employment_status": "Foglalkoztatási státusz",
  "label.end_date": "Befejezés dátuma",
  "label.enter_his_email": "Írja be az e-mail címét",
  "label.entered_transaction_id": "Tranzakció azonosítója",
  "label.first_name": "Keresztnév",
  "label.gender": "Nem",
  "label.goal": "Célkitűzés",
  "label.journey_activity": "Kaland tevékenység",
  "label.journey_objective": "Kaland célkitűzése",
  "label.journey_observations": "Kaland megfigyelések",
  "label.journey_type": "Kaland típusa",
  "label.last_name": "Családnév",
  "label.level": "Szint",
  "label.location": "Helyszín",
  "label.logout": "Kijelentkezés",
  "label.major": "Fő",
  "label.middle_name": "Középső név",
  "label.mode_of_transport": "Utazási mód",
  "label.my_award_leader": "Award líderem",
  "label.name": "Név",
  "label.nationality": "Nemzetiség",
  "label.no": "Nem",
  "label.no_results": "Nincs találat",
  "label.note": "Megjegyzés",
  "label.note_for_assessor": "Megjegyzés kiértékelőnek",
  "label.note_for_leader": "Megjegyzés lídernek",
  "label.optional": "Opcionális",
  "label.organisation_name": "Szervezet neve",
  "label.organisation_type": "Szervezet típusa",
  "label.others": "Egyebek",
  "label.password": "Jelszó",
  "label.password_again": "Jelszó megismétlése",
  "label.project_location": "Projekt helyszíne",
  "label.pay_online": "Online fizetés",
  "label.pay_award_leader_or_unit": "Fizetés lídernek vagy egységnek",
  "label.payment_not_required": "A fizetés nem kötelező a résztvevő esetében",
  "label.payment_type": "Fizetés típusa:",
  "label.phone": "Telefon",
  "label.phone_number": "Telefonszám",
  "label.phone_type": "Telefon típusa",
  "label.profile": "Profil",
  "label.reset_password": "Jelszó megváltoztatása",
  "label.region": "Állam/Tartomány/Régió",
  "label.relationship": "Kapcsolat típusa a résztvevővel",
  "label.role_in_organisation": "Szervezetben betöltött szerep",
  "label.select_country": "Ország vagy terület kiválasztása",
  "label.select_your_au": "Programközpont kiválasztása",
  "label.start_typing": "Kezdje beírni",
  "label.start_date": "Kezdés dátuma",
  "label.select": "Kiválasztás",
  "label.select_async": "Kezdje beírni…",
  "label.select_your_operating_authority": "Operátor partner kiválasztása",
  "label.specify_category": "Adja meg a kategóriát",
  "label.subcategory": "Alkategória",
  "label.title": "Tisztség",
  "label.username": "Felhasználónév",
  "label.what_is_your_role": "Milyen szerepet tölt be a szervezetben?",
  "label.where_have_you_completed": "Hol teljesítette?",
  "label.yes": "Igen",
  "label.your_changes_havent_been_saved": "A módosításai nincsenek mentve. Az adatok elveszhetnek.",
  "label.zip": "Postai irányítószám",
  "label.adventurous_journey": "Kaland",
  "label.after_your_journey_describe": "Pár mondatban foglald össze a kalanddal kapcsolatos megfigyeléseidet.",
  "label.because_your_age_is_under_18": "Mivel még nem töltötted be a 18 évet, szükségünk van a szülő/gyám beleegyezésére.",
  "label.before_you_head_to_journey": "A minősítő kaland megkezdése előtt teljesítened kell a felkészülés és gyakorlás részt.",
  "label.before_entering_new_level": "Mielőtt továbblépnél a következő szintre, igazold, hogy a személyes adataid még mindig érvényesek",
  "label.bring_required_amount_to_your_award_leader": "Vidd be a kért összeget a líderednek vagy programkoordinátorodnak az egységednél.",
  "label.do_you_have_any_other_level": "Teljesítetted a program valamelyik előző szintjét?",
  "label.do_you_know_who_is_your_award_leader": "Tudod a programvezetőd e-mail címét?",
  "label.going_on_an_expedition": "Egy expedícióban való részvétel lehetőséget nyújt  kalandra, csapatmunkára és a kezdeményezésre.",
  "label.going_on_residential_gives_chance": "Egy tartózkodási projektben való részvétel lehetőséget nyújt arra, hogy megtanuld, hogyan dolgozhatsz együtt más hátterű emberekkel, az új környezetben való boldogulás pedig növeli az önbizalmat.",
  "label.i_have_read_the_terms_and_conditions": "Elolvastam és elfogadom az általános feltételeket.",
  "label.i_will_bring_the_consent_to_my_award_leader_later": "Később viszem el a beleegyező nyilatkozatot a líderemnek.",
  "label.if_you_are_from_orphanage": "Például ha az iskolád vagy ifjúsági szervezeted fizeti ki számodra",
  "label.here_you_can_add_activity": "Itt hozzáadhatsz további felkészülés és gyakorlás tevékenységet.",
  "label.how_do_you_want_to_apply": "Hogyan akarsz jelentkezni:",
  "label.my_parent_consent_has_been_already_given": "A szülő/gyám beleegyező nyilatkozata már eljutott a líderemhez.",
  "label.my_parent_will_confirm_consent_by_email": "A szülő/gyám e-mailben fogja igazolni a beleegyezését.",
  "label.major_activity_means_that_you_have_to_spent": "A fő tevékenység azt jelenti, hogy a többihez képest erre a tevékenységre jóval több időt kell szánnod. Az arany és ezüst fokozat esetében az elvárt extra idő hat hónap, a bronz esetében három.",
  "label.not_sure_about_your_auth": "Ha nem vagy biztos benne, hogy melyik Awardkezelő hatóságnál kell regisztrálnod, vedd fel a kapcsolatot az operátor/programközpont kapcsolattartójával.",
  "label.page_not_found": "404 - Az oldal nem elérhető",
  "label.please_fill_in_the_following": "Töltsd ki a szervezeténél az engedélyezést/licencet kezelő kapcsolattartó személy adataival",
  "label.register_a_new_account_as": "Új fiók regisztrációja mint:",
  "label.residential_project": "Aranyfokozatú tartózkodási projekt",
  "label.select_your_award_unit": "Válaszd ki a programközpontot",
  "label.the_expedition_can_be_faraway": "Az expedíció helyszíne bármilyen távolságra lehet az otthonodtól, és számtalan módon megszervezheted.",
  "label.to_log_your_process_on_orb": "Lentebb állítsd be a jelszódat, hogy befejezd az Online Record Book fiókod létrehozását.",
  "label.waiting_for_assessment": "Várakozás kiértékelésre.",
  "label.waiting_for_sign_off": "Várakozás líder jóváhagyására.",
  "label.we_have_sent_you_an_email": "Küldtünk e-mailt, amely tartalmazza az aktiváló linket.",
  "label.what_level_of_the_award": "Az Award melyik szintjére regisztrálsz?",
  "label.you_are_now_registering_as_participant": "Regisztráció program résztvevőként.",
  "label.you_are_now_registering_as_award_unit": "Regisztráció programközpontként.",
  "label.you_can_use_my_photos_for_promotional_purposes": "A program résztvevőjeként beleegyezem abba, hogy az alapítvány a fotóimat/képeimet, valamint (a 2022. augusztus 9. után regisztrált Awardok esetében) a program végén írt személyes gondolataimat a program népszerűsítésére használja.",
  "label.you_can_send_activity_for_approval": "Mostmár elküldheted jóváhagyásra a tevékenységet a kiértékelőnek.",
  "label.you_can_send_activity_for_leader": "Mostmár elküldheted jóváhagyásra a tevékenységet a líderednek.",
  "label.you_can_send_residential_project_to_leader": "Mostmár elküldheted jóváhagyásra az aranyfokozatú tartózkodási projektet a líderednek.",
  "label.you_have_finished_now_send_to_approval": "Befejezted a tevékenységet. Mostmár elküldheted jóváhagyásra a kiértékelőnek. Lentebb személyes megjegyzést is fűzhetsz hozzá.",
  "label.preparation_and_training": "Felkészülés és gyakorlás",
  "label.you_will_be_redirected_to_the_payment": "Kattints a lenti Fizetés gombra, ha online szeretnél fizetni Visa, MasterCard hitelkártyával vagy Visa betéti kártyával.",
  "label.you_will_be_the_first_award_leader": "Ön lesz a szervezeténél a fő líder. Jogában áll további líderek, résztvevők hozzáadása és a program lebonyolításának irányítása az Online Record Book rendszeren keresztül.",
  "label.youll_receive_a_notification": "Értesítést kapsz majd, amikor a lídered jóváhagyta a regisztrációdat. Az Online Record Book platformra a következő módokon tudsz bejelentkezni (mindaddig, amíg a líder jóvá nem hagyja a regisztrációdat, csak korlátozott hozzáférésed van):",
  "label.your_parent_email": "A szülő/gyám e-mail címe",
  "label.your_parent_first_name": "A szülő/gyám keresztneve",
  "label.your_parent_last_name": "A szülő/gyám családneve",
  "label.your_report_approve_now_send_to_leader": "A jelentésed jóváhagyása megtörtént! Most már elküldheted a lídernek jóváhagyásra. Lentebb személyes megjezgyést is hozzáfűzhetsz.",
  "label.there_are_loads_of_exciting_possibilities": "Számtalan izgalmas lehetőség áll rendelkezésedre. Válassz ki valamit, ami számodra az önmegvalósítást jelentheti.",
  "label.your_residential_project_has_been_setup": "Az aranyfokozatú tartózkodási projekted beállításait rögzítettük és elküldtük a lídernek jóváhagyásra.",
  "label.your_report_has_been_sent_assessor": "A jelentésedet elküldtük jóváhagyásra a kiértékelőnek.",
  "label.your_report_has_been_sent_leader": "A jelentésedet elküldtük jóváhagyásra a lídernek.",
  "label.your_residential_project_is_complete": "Az aranyfokozatú tartózkodási projekted teljesítve.",
  "label.to_work_on_the_online": "Az Online Record Book (ORB) platform igénybevételéhez saját ORB fiókra van szükség.",
  "label.we_will_send_you_an_email": "Küldünk egy e-mailt, amikor az ORB fiók regisztrációjának a jóváhagyása megtörtént.",
  "label.if_you_have_any_problems_or_doubts": "Ha bármilyen probléma vagy kérdés merül fel, további információkért a programközponthoz kell fordulni.",
  "label.are_you_sure_you_want_to_leave": "Biztos ki akarsz lépni? Az adatok elvesznek.",
  "label.menu": "Menü",
  "notifications.award_unit_has_been_created": "Programközpont létrehozása megtörtént",
  "notifications.authorization_code_is_not_valid": "Engedély kódja nem érvényes - korábban már használta ezt a kódot",
  "notifications.email_has_been_confirmed": "E-mail cím visszaigazolva",
  "notifications.leader_has_been_created": "Líder létrehozva",
  "notifications.participant_has_been_created": "Résztvevő létrehozva",
  "notifications.email_with_instructions_has_been_sent": "Útmutatásokat tartalmazó e-mail elküldve",
  "notifications.your_new_password_has_been_set": "Új jelszó beállítása megtörtént",
  "notifications.success": "Siker",
  "notifications.unknown_role": "Ismeretlen szerep",
  "notifications.waiting_for_approval": "Jóváhagyásra várva",
  "notifications.activity_cannot_be_created": "A regisztráció jóváhagyása előtt nem lehet létrehozni a tevékenységet ",
  "notifications.new_activity_has_been_added": "Új tevékenység hozzáadva",
  "notifications.new_log_has_been_added": "Új napló hozzáadva",
  "notifications.log_has_been_deleted": "Napló törölve",
  "notifications.log_has_been_modified": "Napló módosítva",
  "notifications.adventurous_journey_cannot_be_created_until_approved": "A regisztráció jóváhagyása előtt nem lehet létrehozni a kalandot",
  "notifications.new_participant_event_has_been_added": "Új résztvevői esemény hozzáadva",
  "notifications.participant_event_has_been_completed": "Résztvevői esemény teljesítve",
  "notifications.training_and_practice_modified": "Felkészülés és gyakorlás módosítva",
  "notifications.completion_residential_project_completed": "Aranyfokozatú tartózkodási projekt teljesítve",
  "notifications.new_residential_project_has_been_added": "Új aranyfokozatú tartózkodási projekt hozzáadva",
  "notifications.residential_project_cannot_be_created_until_approved": "A regisztráció jóváhagyása előtt nem lehet létrehozni az aranyfokozatú tartózkodási projektet",
  "notifications.already_assessed_sent": "Kérés líderi jóváhagyásra elküldve",
  "notifications.assessment_request_sent": "Kiértékelés kérése elküldve",
  "notifications.leader_approval_sent": "Kérés líderi jóváhagyásra elküldve",
  "tabs.logs": "Naplók",
  "tabs.new": "Új",
  "tabs.overview": "Áttekintés",
  "tabs.report": "Jelentés",
  "button.add_activity": "Tevékenység hozzáadása",
  "button.add_log": "Napló hozzáadása",
  "button.continue_here": "Tovább innen",
  "button.continue": "Tovább",
  "button.continue_to_award": "Tovább az Awardhoz",
  "button.delete": "Törlés",
  "button.edit": "Szerkesztés",
  "button.edit_log": "Napló szerkesztése",
  "button.finish": "Befejezés",
  "button.forgot_your_password": "Elfelejtette a jelszavát?",
  "button.i_already_have_assessment": "Már van kiértékelésem",
  "button.leave_anyway": "Kilépés mindenképp",
  "button.login": "Bejelentkezés",
  "button.no": "Nem",
  "button.register": "Regisztráció",
  "button.send": "Elküldés",
  "button.send_for_approval": "Elküldés jóváhagyásra",
  "button.setup": "Beállítás",
  "button.setup_residential": "Aranyfokozatú tartózkodási projekt beállítása",
  "button.stay": "Maradás",
  "button.submit": "Beadás",
  "button.update": "Frissítés",
  "button.yes": "Igen",
  "errors.at_least_num_characters": "Legalább {length} karakter hosszúságú",
  "errors.do_not_match": "Ne párosítsa",
  "errors.include_at_least_one_number": "Iktasson be legalább egy számjegyet",
  "errors.include_both_lower_and_upper_case": "Iktasson be kis és nagybetűket is",
  "errors.invalid_phone_format": "Érvénytelen telefonszám formátum",
  "errors.invalid_email_address": "Érvénytelen e-mail cím formátum",
  "errors.required_field": "Kötelező mező",
  "errors.must_be_at_least": "Legkevesebb karakterszám {min}",
  "errors.must_be_no_more_than": "Nem lehet több, mint {max} karakter",
  "errors.must_be_an_integer": "Egész számnak kell lennie",
  "errors.must_contain_at_least": "Legalább az egyik számjegy kell legyen",
  "errors.must_include_at_least": "Legalább az egyik nagybetűs karakter kell legyen",
  "errors.must_be_one_of": "Kötelezően ezek közül az egyik: {enums}",
  "errors.you_must_be_younger_than": "{years} év és {months} hónap korúnál fiatalabbnak kell lenned a díjra való regisztrációhoz. Beszéld meg ezt a programközpont alkalmazottaival.",
  "errors.you_must_be_older_than": "{years} év és {months} hónap korúnál idősebbnek kell lenned a díjra való regisztrációhoz. Beszéld meg ezt a programközpont alkalmazottaival.",
  "errors.email_address_is_in_use_please_sign": "E-mail cím már használatban, ha regisztrálni akarsz egy másik szintre, jelentkezz be a fiókodba.",
  "errors.email_address_is_in_use": "E-mail cím már használatban.",
  "wizard.authorising_contact": "Kapcsolattartó/Licenc birtokosa engedélyezése",
  "wizard.award_leader_contact": "Programkoordinátor elérhetősége",
  "wizard.award_unit_details": "Programközpont adatai",
  "wizard.contact_details": "Elérhetőség",
  "wizard.contacts": "Elérhetőségek",
  "wizard.level": "Award fokozat",
  "wizard.level_selection": "Award kiválasztása",
  "wizard.leader_details": "Líder adatai",
  "wizard.nominated_award_leader": "Programkoordinátor",
  "wizard.orb_account": "ORB fiók",
  "wizard.parent_consent": "Szülői beleegyezés",
  "wizard.participant_details": "Résztvevő adatai",
  "wizard.profile": "Profil",
  "wizard.payment": "Fizetés",
  "wizard.select_award_unit": "Programközpont kiválasztása",
  "wizard.unit_details": "Egység adatai",
  "wizard.welcome": "Üdvözöljük",
  "wizard.your_details": "Adataid",
  "awardUnit.do_you_want_to_create": "Új programközpontot akar létrehozni?",
  "parent.you_can_download_the_consent_here": "Ha még nincs meg a Szülői beleegyezés nyomtatvány, innen letöltheted. Miután a szülőd/gyámod aláírta, küldd el a líderednek.",
  "footer.copyright": "Jogdíj The Duke of Edinburgh’s International Award  2019",
  "registration_participant.required_award_payment": "Programban való részvétel kifizetése kötelező",
  "registration_participant.pay_online_here": "Online kifizetés és tranzakció azonosító kikérése itt.",
  "dashboard.activity_log_time": "{hours}óra {minutes}perc",
  "moduleTitle.award_completed": "Award teljesítve!",
  "notifications.award_approval_request_sent_to_leader": "Award jóváhagyási kérés elküldve a lídernek",
  "notifications.new_participant_event_has_been_completed": "Új résztvevői esemény teljesítve",
  "notifications.preparation_and_training_approval_sent": "Felkészülés és gyakorlás jóváhagyása elküldve",
  "notifications.reparation_and_training_completed": "Felkészülés és gyakorlás teljesítve",
  "notifications.your_profile_photo_has_been_edited": "Profilképed szerkesztése megtörtént",
  "notifications.your_profile_has_been_edited": "A profilod szerkesztése megtörtént",
  "notifications.new_level_has_started": "A következő szint elkezdődött",
  "notifications.activity_has_been_edited": "Tevékenység szerkesztve",
  "notifications.you_have_been_logged_out": "Kijelentkezés…",
  "notifications.logging_out": "Kijelentkeztél",
  "label.you_can_send_award_to_leader": "Most már elküldheted jóváhagyásra az Awardod a lídernek",
  "label.you_have_completed_all_sections_of_your_award": "Elküldheted jóváhagyásra az Awardot a programvezetőnek",
  "label.you_have_now_completed_your_award": "Teljesítetted az Award {level} szintjét. El akarod kezdeni a következő szintet?",
  "moduleTitle.settings": "Beállítások",
  "moduleTitle.edit_activity": "Tevékenység szerkesztése",
  "moduleTitle.select_your_major_activity": "Fő tevékenység kiválasztása",
  "label.settings": "Beállítások",
  "label.major_activity_means_that_you_will": "A fő tevékenység azt jelenti, hogy a többihez képest erre a tevékenységre jóval több időt kell szánnod. Az arany és ezüst fokozat esetében az elvárt extra idő hat hónap, a bronz esetében három.",
  "label.notifications": "Értesítések",
  "label.my_award": "Az Awardom",
  "label.physical_recreation": "Testmozgás",
  "label.skill": "Készség",
  "label.service": "Önkéntes szolgálat",
  "label.my_parent_will_complete_and_sign_form": "A szülőm/gyámom kitölti és aláírja a beleegyező nyilatkozatot",
  "label.please_print_it_tak_it_to_your_parent": "Lentebb letöltheted a Szülői beleegyezés nyomtatványt. Vidd el a szülőnek/gyámnak, hogy írja alá, majd add át a líderednek.",
  "label.change_password": "Jelszó megváltoztatása",
  "label.change_major_activity": "Fő szakasz megváltoztatása",
  "title.change_password": "Jelszó megváltoztatása",
  "label.old_again": "Régi jelszó",
  "label.new_password": "Új jelszó",
  "label.new_password_again": "Új jelszó ismét",
  "errors.passwords_dont_match": "Nem azonos a két jelszó",
  "errors.more_than": "Több mint {limit}",
  "button.parent_guardian_consent_pdf": "Szülő/gyám beleegyezés.pdf",
  "button.send_award_for_approval": "Award elküldése jóváhagyásra",
  "button.send_report": "Jelentés elküldése",
  "button.terms_and_conditions": "ORB általános feltételek",
  "button.privacy_policy": "Adatvédelmi szabályzat",
  "button.save": "Mentés",
  "button.start_new_level": "Következő szint elkezdése",
  "button.change_password": "Jelszó megváltoztatása",
  "button.edit_activity": "Tevékenység szerkesztése",
  "moduleTitle.file_upload": "Fájl feltöltése",
  "label.add_file": "Fájl hozzáadása",
  "label.description": "Leírás",
  "label.waiting_for_office_sign_off": "Várakozás programközpont jóváhagyására.",
  "notifications.file_has_been_uploaded": "Fájl feltöltve",
  "tabs.files": "Fájlok",
  "button.upload": "Feltöltés",
  "button.upload_file": "Fájl feltöltése",
  "button.add_file": "Fájl hozzáadása",
  "button.this_activity_has_no_assessor": "A tevékenységhez nincs kiértékelő megjelölve. Mielőtt elküldenéd jóváhagyásra, be kell állítanod a kiértékelő adatait.",
  "label.i_want_to_register_my_award": "A programközpontomat független programközpontként akarom regisztrálni",
  "label.select_sub_operating_authority": "Operátor partneri alegység kiválasztása",
  "label.your_must_first_setup_some_activity": "Először tevékenységet kell beállítanod",
  "label.you_cant_change_your_major_activity": "Nem változtathatod meg a fő tevékenységet. Már teljesítetted a fő tevékenységet",
  "label.you_can_upload_here_any_files": "Itt feltölthetsz bármilyen fájlt (legfeljebb 10mb terjedelműt), amit meg akarsz osztani a lídereddel.",
  "moduleTitle.login_change": "Bejelentkezés megváltoztatása",
  "notifications.adventurous_journey_modified": "Kaland módosítva",
  "tabs.sections": "Szakaszok",
  "label.change_email": "E-mail megváltoztatása",
  "title.change_email": "E-mail megváltoztatása",
  "label.new_email": "Új e-mail",
  "label.new_email_again": "Új e-mail igazolása",
  "errors.emails_dont_match": "A két e-mail cím nem egyezik",
  "button.change_email": "E-mail megváltoztatása",
  "notifications.email_with_instructions_has_been_sent_to_your_inbox": "Útmutatásokat tartalmazó e-mail elküldve az inboxodba",
  "global.dofe_name": "The Duke of Edinburgh’s International Award",
  "global.or": "vagy",
  "route.landing_page": "Nyitóoldal",
  "route.dashboard": "Irányítópult",
  "moduleTitle.notifications": "Értesítések",
  "moduleTitle.no_notifications": "Nincs értesítés",
  "moduleTitle.new_notifications": "Új értesítés",
  "moduleTitle.older_notifications": "Régi értesítések",
  "moduleTitle.user_guide": "Használati útmutató",
  "label.user_guide": "Használati útmutató",
  "notifications.your_password_has_been_changed": "A jelszód megváltozott",
  "label.country": "Ország / Terület",
  "label.on_your_smartphone": "Az okostelefonodra",
  "label.on_the_web": "A webre",
  "label.orb_online": "ORB Online",
  "label.language": "Nyelv",
  "moduleTitle.participant_login": "Résztvevő bejelentkezés",
  "label.for_ios": "iOS",
  "label.for_android": "Android",
  "button.login_as_award_staff": "Bejelentkezés személyzetként",
  "errors.leader_doesnt_exist": "Líder nem létezik",
  "global.loading": "Betöltés",
  "moduleTitle.award_staff_login": "Bejelentkezés",
  "formTitle.residential_project_details": "Aranyfokozatú tartózkodási projekt adatai",
  "notifications.this_role_is_not": "A szerep jelenleg nem támogatott",
  "notifications.residential_project_has_been_updated": "Aranyfokozatú tartózkodási projekt frissítve",
  "tabs.participant": "Résztvevő",
  "tabs.award_staff": "Award személyzet",
  "moduleTitle.edit_residential_project": "Aranyfokozatú tartózkodási projekt szerkesztése",
  "button.residential_project": "Aranyfokozatú tartózkodási projekt szerkesztése",
  "notifications.your_login_email_has_been_changed": "A bejelentkezéshez használt e-mail címed megváltozott",
  "meta.dofe_name": "The Duke of Edinburgh’s International Award",
  "notifications.unknown_role_leader": "Ismeretlen szerep - Használja az Award személyzet azonosítót",
  "notifications.unknown_role_participant": "Ismeretlen szerep - Használja a Résztvevő azonosítót",
  "label.user_guide_web_participant": "Webes felhasználói útmutató - résztvevő",
  "label.user_guide_app_participant": "Felhasználói útmutató applikáció - résztvevő",
  "label.note_for_supervisor": "Megjegyzés felügyelőnek",
  "label.before_submitting_your_aj": "Mielőtt elküldenéd a kalandot a lídernek, meg kell szerezned {role} jóváhagyását. Ha akarod, itt megjegyzést is küldhetsz.",
  "button.back_to_home": "Vissza a kezdőlapra",
  "moduleTitle.assessor_approval": "{role} jóváhagyás",
  "label.this_aj_has_no_assessor": "A kalandhoz nincs kijelölve {role}. Frissítened kell az adatokat, mielőtt elküldenéd jóváhagyásra.",
  "route.not_found": "Nem található",
  "notifications.are_you_sure": "Biztos?",
  "button.cancel": "Mégsem",
  "label.add_document": "Dokumentum hozzáadása",
  "errors.there_are_currently_no_details_for_your": "Jelenleg nincsenek adatok a/z {role} szerephez. Töltsd ki a hiányzó adatokat, mielőtt elküldenéd a tevékenységet jóváhagyásra",
  "moduleTitle.missing_data": "Hiányzó adat",
  "label.to_send_assessment_request": "Ha elektronikusan akarod elküldeni a kiértékelés kérést, add meg a/z {role} e-mail címét",
  "label.pending_changes": "Módosítások függőben…",
  "label.some_fields_require": "Vannak még megoldásra váró mezők",
  "roles.assessor": "Kiértékelő",
  "roles.supervisor": "Felügyelő",
  "pageTitle.register_participant": "Résztvevő regisztrációja",
  "moduleTitle.revise_message": "Üzenet átnézése",
  "moduleTitle.payment_for_level": "Fizetés a következőért {awardLevel}",
  "moduleTitle.payment": "Résztvevői regisztrációs díjak fizetése",
  "moduleTitle.we_have_sent_you_payment_link": "Küldtünk egy e-mailt, amely tartalmazza a fizetési átjáróhoz vezető linket.",
  "label.required_award_payment": "Award kifizetése kötelező",
  "label.payment_fees": "Fizetési díjak",
  "label.payment_method": "Fizetési mód",
  "label.you_will_type_trans_id": "Be kell majd írnod a tranzakció számát.",
  "label.any_level_previously": "Az ORB platformon kívül korábban teljesített szintek",
  "label.registering_for_level": "Új szint regisztrálása",
  "notification.payment_link_expired": "Fizetési link érvényessége lejárt",
  "button.pay": "Fizetés",
  "label.registration_updated": "A regisztráció frissítve, mostmár lezárhatod ezt az oldalt.",
  "label.award_leader_receive_payment": "A líder tájékoztatást kap a kifizetésről.",
  "errors.end_date_after": "A befejezés dátuma nem lehet korábbi a kezdés dátumánál",
  "button.back": "Vissza",
  "button.edit_info": "Információ szerkesztése",
  "moduleTitle.level_detail": "Szint adatai",
  "label.payment_methods": "Fizetési módok",
  "label.address": "Cím",
  "note.review_filled_participant": "Olvasd át a következő információkat.",
  "moduleTitle.payment_successful": "Résztvevői regisztráció kifizetése sikeres volt",
  "button.proceed_to_login": "Tovább a bejelentkezéshez",
  "label.add_additional_activity": "Kiegészítő tevékenység hozzáadása",
  "moduleTitle.welcome_to_orb": "Üdv az Online Record Book (ORB) platformon",
  "empty_dashboard.not_approved": "Az eszköz segít rögzíteni a program teljesítése során elért eredményeidet. A profilodat azonban a lídered még nem hagyta jóvá. Az első tevékenységed létrehozása előtt meg kell várnod a jóváhagyást.",
  "empty_dashboard.approved_1": "Az ORB eszköz, amely segít neked rögzíteni az Awarddal kapcsolatos tevékenységeket és eredményeket.",
  "empty_dashboard.approved_2": "Kezdd azzal, hogy kattints rá a bal oldalon levő szakaszokra, add hozzá midegyikhez a kiválasztott tevékenységet és a tevékenység kiértékelőjének az adatait.\n\nAmint a líder jóváhagyott egy tevékenységet, elkezdheted a tevékenységi naplók hozzáadását, és ez máris előrehaladást jelent!\n\nHa a tevékenységek során segítségre van szükséged, fordulj a líderedhez.\n",
  "label.discuss_activity_leader": "Ha egynél több tevékenységet akarsz kiválasztani, beszéld ezt meg a lídereddel.",
  "label.cannot_add_activity": "Ebben a kategóriában legfeljebb 3 tevékenységet adhatsz hozzá. Beszéld meg a lídereddel.",
  "button.ok": "OK",
  "label.payment_was_canceled": "A felhasználó leállította a fizetést.",
  "label.problem_with_payment": "Hiba lépett fel a fizetés feldolgozása közben. Vedd fel a kapcsolatot az országos programoperátorral.",
  "pageTitle.register_leader": "Vezető regisztrálása",
  "pageTitle.registration_complete": "Regisztráció befejezve",
  "label.payment_link_expired_or_paid": "Már kifizetted a regisztrációs díjakat VAGY a fizetési link érvényessége lejárt.",
  "label.contact_nao_assistance": "Vedd fel a kapcsolatot az országos programoperátorral, ha segítségre van szükséged.",
  "label.send_required_amount_to_your_award_leader": "A kért összeg elküldése a lídernek vagy az egység programkoordinátorának.",
  "label.fee_can_be_paid": "A díj kifizethető online VISA, Mastercard hitelkártyával vagy betéti kártyával.",
  "notifications.login_failed_right_tab": "Bejelentkezés sikertelen. Ellenőrizd, hogy a megfelelő menüpontot választottad-e (Résztvevő / Award személyzet).",
  "label.i_have_read_privacy_policy": "Elolvastam az adatvédelmi tájékoztatót.",
  "errors.invalid_date_format": "Érvénytelen dátumformátum",
  "label.no_privacy_policy": "A befejezés gombra kattintva tovább léphetsz.",
  "label.status": "Státusz",
  "moduleTitle.attached_with_observation": "Csatolva megjegyzéssel",
  "moduleTitle.revise_message_rp": "A lídered visszaküldte az aranyfokozatú tartózkodási projektet.",
  "file.activity_section_summary": "{section}-szakasz-összefoglaló",
  "label.download_section_summary": "Szakasz összefoglaló letöltése",
  "label.award_summary": "Award összefoglaló",
  "btn.download_summary_for_assessor": "Összefoglaló letöltése kiértékelőnek",
  "label.first_activity_started": "Első tevékenység elkezdve",
  "label.hours_completed_required": "Teljesített/kötelező óraszám",
  "label.weeks_completed_required": "Teljesített/kötelező hetek",
  "back_to_home": "Vissza a kezdőlapra",
  "label.activity_rejected_click": "A lídered visszaküldte a tevékenységet.",
  "button.more_information": "Bővebb információk",
  "label.attached_file": "Csatolt fájl",
  "moduleTitle.journey_details": "Kaland adatai",
  "tabs.activity": "Tevékenység",
  "label.confirm_email": "E-mail visszaigazolása",
  "label.aj_rejected_click": "A lídered visszaküldte a kalandot.",
  "label.verifying_payment": "Kifizetés ellenőrzése",
  "button.finish_and_pay": "Befejezés és fizetés",
  "label.payment_not_successful_text": "Mivel a kifizetés nem volt sikeres, most végre kell hajtanod a kifizetést",
  "label.payment_not_completed": "Kifizetés nincs teljesítve",
  "button.pay_now": "Fizetés most",
  "label.registration_pending_parental_consent": "Regisztráció függőben szülő/gyám beleegyezése miatt",
  "button.edit_observation": "Megjegyzés szerkesztése",
  "moduleTitle.qualifying": "Minősítő",
  "moduleTitle.practice": "Gyakorló",
  "label.first_log_entry": "Első naplóbejegyzés",
  "label.first_log_entry_date": "Első naplóbejegyzés dátuma",
  "label.last_log_entry": "Utolsó naplóbejegyzés",
  "label.last_log_entry_date": "Utolsó naplóbejegyzés dátuma",
  "label.you_can_send_journey_report_for_approval": "Elküldheted jóváhagyásra a/z {journey} kaland jelentést.",
  "button.edit_and_resend_report": "Jelentés szerkesztése és újraküldése",
  "label.your_journey_is_complete": "{journeyType} Kaland teljesítve.",
  "button.add_additional_journey": "Kiegészítő kaland hozzáadása",
  "moduleTitle.edit_journey": "Kaland szerkesztése",
  "notifications.assessment_sent": "Kiértékelés elküldve",
  "notifications.file_is_too_big": "A fájl nem feltölthető. Fájlméret legfeljebb 10mb lehet.",
  "notifications.authorization_code_has_expired": "Engedélyezési kód biztonsági okokból lejárt, kérjen új kódot",
  "route.confirm_email": "E-mail visszaigazolása",
  "label.company_name": "Cég neve",
  "label.secondary_email_again": "Másodlagos e-mail visszaigazolása",
  "label.how_many_years": "Hány éve/hónapja?",
  "label.no_company_leave_empty": "Ha nem dolgozik cégnél, hagyja üresen",
  "label.secondary_phone_number": "Másodlagos telefonszám",
  "label.secondary_phone_type": "Másodlagos telefon típusa",
  "label.wwc_application_number": "Gyerekvédelmi azonosító",
  "label.wwc_expiration_date": "Gyerekvédelmi státusz lejártának dátuma",
  "label.you_are_now_registering_as_assessor": "Kiértékelőként regisztrált.",
  "label.you_have_finished_aj_now_send_to_approval": "A kaland végetért. Mostmár elküldheted a kiértékelőnek jóváhagyásra. Lentebb személyes megjegyzést is hozzáfűzhetsz.",
  "label.your_experience": "Tapasztalat",
  "label.your_qualification": "Képzettség",
  "notifications.waiting_for_assessor_approval": "Várakozás a kiértékelő jóváhagyására",
  "button.resend_assessment_request": "Kiértékelés kérés újraküldése",
  "errors.emails_must_be_different": "A másodlagos e-mail nem lehet ugyanaz, mint az elsődleges.",
  "moduleTitle.company_details": "Cég adatai",
  "notifications.already_resent_assessment_request": "Már újraküldted a kiértékelés kérést",
  "route.assessor_dashboard": "Kiértékelői irányítópult",
  "pageTitle.register_assessor": "Kiértékelő regisztrálása",
  "wizard.assessor_details": "Kiértékelő adatai",
  "wizard.assessor_experience": "Kiértékelő tapasztalata",
  "wizard.personal_details": "Személyes adatok",
  "button.sign_off": "Jóváhagyás",
  "button.sign_off_dashed": "Jóváhagyás",
  "moduleTitle.sign_off": "Jóváhagyás",
  "label.certify_participant_met_reqs": "A tevékenység kiértékelőjeként igazolom, hogy a résztvevő teljesítette az elvárásokat.",
  "label.assessor_report": "Kiértékelői jelentés",
  "label.content_update": "Várjon. Tartalom frissítése…",
  "label.comment_on_participant_improvement": "Fogalmazza meg észrevételeit a résztvevő fejlődéséről/elköteleződéséről",
  "note.edit_participant_review": "Az információk javításához kattintson az Információk szerkesztése menüpontra.",
  "errors.min_age": "Alsó korhatár {age}",
  "notifications.assessor_link_expired": "Kiértékelő regisztrációs link érvényessége lejárt.",
  "label.secondary_email": "Másodlagos e-mail",
  "moduleTitle.review_participant_info": "Résztvevői információk áttekintése",
  "label.loading_payment_gateway": "Fizetési átjáró betöltése",
  "label.consent_given_login_as_child": "Beleegyezés már rögzítve. Jelentkezzen be a gyereke azonosítójával.",
  "notifications.only_one_qualification_journey_per_award": "A program keretében csak egy minősítő kalandot lehet beállítani",
  "label.registration_fees_participant": "Regisztrációs díjak kifizetése - {name} (#{id})",
  "moduleTitle.leader_details": "Líder adatai",
  "label.leader_name": "Líder neve",
  "label.leader_phone": "Líder telefonszáma",
  "label.leader_email": "Líder e-mail címe",
  "moduleTitle.au_details": "Programközpont adatai",
  "label.au_name": "Programközpont neve",
  "label.assessor_guidelines": "Útmutató",
  "label.assessor_cond_req": "Alapvető feltételek",
  "label.assessor_ref_handbook": "Hivatkozás az Award kézikönyvére",
  "label.assessor_ref_online_modules": "Hivatkozás az online oktatási modulokra",
  "label.participant_has_no_aj_report": "A résztvevő még nem küldött be jelentést.",
  "moduleTitle.participant_details": "Résztvevő adatai",
  "label.participants_has_no_logs": "Még nincs naplóbejegyzésed.",
  "label.location_type": "Helyszín típusa",
  "label.activity_ready_for_signoff": "A tevékenység jóváhagyható.",
  "label.activities": "Tevékenységek",
  "label.choose_how_you_want_to_login": "Bejelentkezés módja:",
  "roles.leader": "Líder",
  "roles.award_verifier": "Award ellenőr",
  "roles.coordinator": "Koordinátor",
  "roles.aj_assessor": "Kaland kiértékelő",
  "roles.aj_supervisor": "Kaland felügyelő",
  "roles.instructor": "Oktató",
  "roles.nao_staff": "Országos programoperátor személyzet",
  "roles.super_user": "Szuper-felhasználó",
  "roles.user": "Felhasználó",
  "roles.viewer": "Megtekintő",
  "roles.authorizing_contact": "Kapcsolattartó jóváhagyása",
  "roles.if_staff_superuser": "IAF szuper-felhasználó személyzet",
  "roles.if_staff_statistical_user": "IF statisztikai felhasználó",
  "roles.if_staff_viewer": "IAF megtekintő személyzet",
  "roles.aj_instructor": "Kaland oktató",
  "label.if_you_have_questions_au": "Ha kérdése van a regisztrációval kapcsolatban, vegye fel a kapcsolatot a programközponttal.",
  "label.we_will_send_you_an_email_leader": "Az ORB fiók regisztrációjának a jóváhagyása után küldünk egy e-mailt.",
  "moduleTitle.rejecting_assessor_invitation": "Kiértékelőként való felkérés visszautasítása",
  "notifications.assessor_invitation_rejected": "Kiértékelőként való felkérés visszautasítva",
  "moduleTitle.participants_list_is_empty": "Résztvevők listája üres",
  "label.note_from_participant": "Megjegyzés a résztvevőtől",
  "label.you_can_send_aj_to_leader": "Most már elküldheted jóváhagyásra a kalandot a líderednek.",
  "button.save_report": "Jelentés mentése",
  "label.this_activity_has_no_assessor": "A tevékenységhez nincs kiértékelő megjelölve. Mielőtt elküldenéd jóváhagyásra, ki kell tölteni a kiértékelő adatait.",
  "label.activity_rejected_click_by_assessor": "A kiértékelő visszaküldte a tevékenységet. Kattints a␣\n",
  "button.reject": "Elutasítás",
  "button.reject_invitation": "Felkérés elutasítása",
  "label.reason": "Ok",
  "label.accept_invitation_and_continue": "Felkérés elfogadása és továbblépés",
  "pageTitle.registration_reject": "Regisztráció elutasítása",
  "errors.you_must_be_older_than_register_for_leader": "{years} év és {months} hónapnál idősebbnek kell lennie ahhoz, hogy líderként regisztráljon.",
  "label.your_report_approve_now_send_to_leader_without_note": "A jelentésedet jóváhagyták! Mostmár továbbküldheted a lídernek jóváhagyásra.",
  "button.stop_assessing_this_activity": " Tevékenység kiértékelésének leállítása",
  "button.confirm": "Megerősítés",
  "moduleTitle.are_you_sure": "Biztos?",
  "label.content_restore": "Tartalom visszaállítása",
  "button.stop_editing": "Szerkesztés leállítása",
  "notifications.activity_has_been_rejected": "A tevékenységet visszaküldték felülvizsgálatra.",
  "notifications.aj_has_been_rejected": "A kaland visszaküldve felülvizsgálatra.",
  "notifications.rp_has_been_rejected": "Az aranyfokozatú tartózkodási projektet visszaküldték felülvizsgálatra.",
  "moduleTitle.additional_files": "További fájlok",
  "moduleTitle.no_additional_files": "További fájlok",
  "moduleTitle.stop_assessing_section": "Szakasz kiértékelésének leállítása",
  "label.show_security_and_refund_policy": "Fizetési és visszatérítési információk",
  "moduleTitle.security_and_refund_policy": "Biztonsági és visszatérítési szabályzat",
  "label.fees_payment": "Díjak kifizetése",
  "label.redund_policy": "Visszatérítési szabályzat",
  "label.security_policy": "Biztonsági szabályzat",
  "label.leave_blank": "Üresen marad",
  "label.frequently_asked_questions": "Gyakori kérdések (GYIK)",
  "label.language_selection_is_disabled_for_iac": "Nyelv kiválasztása nem engedélyezett",
  "errors.min_nights_required": "Az elvárás legkevesebb {nights} éjszaka",
  "label.completion_date": "Teljesítés dátuma",
  "label.you_are_offline": "Offline üzemmódban van. A mostani változtatások elveszhetnek.",
  "errors.start_date_after_award_start": "A kezdés dátuma nem lehet korábbi, mint az aktuális Award kezdete.",
  "label.participants": "Résztvevők",
  "label.marketing_from_iaf": "Jelölje be, ha szeretne marketing anyagokat kapni az Alapítványtól.",
  "label.marketing_from_oa": "Jelölje be, ha szeretne marketing anyagokat kapni a programoperátortól.",
  "label.marketing_from_nao": "Jelölje be, ha szeretne marketing anyagokat kapni az országos programoperátortól.",
  "label.select_iac": "Független programközpont kiválasztása",
  "label.you_will_be_redirected_to_the_paypal_payment": "Kattintson a fenti Fizetés gombra az online kifizetéshez Visa, Mastercard hitelkártával, Visa betéti kártyával vagy PayPal számláról való fizetéshez.",
  "notifications.report_has_been_sent": "Jelentés elküldve",
  "label.processing_paypal_payment": "PayPal kifizetés feldolgozása",
  "label.loading_paypal_gateway": "PayPal fizetési átjáró betöltése",
  "label.payment_failed": "Fizetés sikertelen",
  "label.payment_has_been_cancelled": "Fizetés visszavonva vagy sikertelen",
  "roles.naa_oa_staff": "Országos programoperátor személyzet",
  "label.download_report_and_upload_signed_version": "Jelentés letöltése és aláírt változat feltöltése",
  "button.download_summary_for_assessor": "Összefoglaló letöltése kiértékelőnek",
  "label.pay_online_mastercard": "Online fizetés",
  "label.pay_online_paypal": "Online fizetés",
  "notifications.authorization_code_is_missing": "Hiányzó engedélyezési kód",
  "errors.unknown_payment_error": "Fizetés közben ismeretlen hiba lépett fel",
  "errors.already_in_use_by_auth_contact": "Az e-mail címet az engedélyező kapcsolattartó már használja",
  "roles.if_staff_stat_user": "IF statisztikai felhasználó",
  "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Inaktivitás miatt kilépett",
  "announcement.survey_description.do_think_people_are_lazy": "Mit gondol, a mai fiatalok lusták vagy kiváltságosak? Akár fiatal vagy felnőtt, töltse ki az egyik kérdőívünket, és mondja el, hogy ÖN mit gondol a mai fiatalokról.",
  "announcement.survey_title.join_our_global_survey": "Részvétel a globális felmérésben",
  "announcement.survey_button.if_below_25": "Ha 16-25 éves",
  "announcement.survey_button.if_over_25": "Ha 25 évesnél idősebb",
  "moduleTitle.privacy_and_cookie_policy": "Adatvédelmi szabályzat és sütik kezelése",
  "label.we_have_made_some_important_changes": "Fontos változtatásokat vezettünk be az adatvédelmi és sütikezelési szabályzatunkba, és szeretnénk, ha tudná, mit jelent ez önre és az adataira nézve.",
  "button.i_agree": "Egyetértek",
  "button.see_more_details": "További részletek megtekintése",
  "label.the_cookie_settings_on_this": "Ezen az oldalon a sütik beállítása \"engedélyezett\" hogy a lehető legjobban böngészhető legyen. Ha a sütibeállítások módosítása nélkül használja továbbra is az oldalt, vagy ha a lenti \"elfogadom\" opcióra kattint, ezzel elfogadja a szabályzatot.",
  "label.after_your_rp_describe": "Pár mondatban fogalmazd meg az aranyfokozatú tartózkodási projekttel kapcsolatos észrevételeidet.",
  "label.you_are_going_to_be_logged_out": "Inaktivitás miatt a rendszer hamarosan kiléptet.",
  "label.orb_participant_app": "ORB résztvevői applikáció",
  "label.orb_participant_app_button": "Kiválasztom",
  "errors.email_or_phone_required": "E-mail vagy telefonszám kötelező",
  "button.download_info_for_assessor": "Információk letöltése kiértékelőnek",
  "label.assessor_details": "A kiértékelő ellenőrzi a résztvevő előrehaladását, és jóváhagyja a program egy kiválasztott tevékenységének a teljesítését. Bárki lehet kiértékelő, aki hajlandó másoknak segíteni a céljaik elérésben, vannak ismeretei a résztvevői által választott tevékenységekről, és a tevékenység végén ki tudja értékelni a résztvevők erőfeszítéseit. A kiértékelést e-mailben kérjük majd a tevékenység befejezésekor.",
  "notifications.login_failed": "Bejelentkezés sikertelen",
  "label.award_unit": "Programközpont",
  "label.you_can_send_report_to_award_leader": "Elküldheted a jelentést a programvezetőnek.",
  "btn.download_award_summary": "Award összefoglaló letöltése",
  "label.direct_money_transfer": "Közvetlen utalás",
  "label.you_need_pay_to_nao_acc": "Az országos programoperátorhoz tett utalással kell kifizetned a kiválasztott szintre való regisztráció díját.",
  "label.you_will_be_redirected_to_the_global_payments": "Átirányítunk a Global Payments Gateway rendszerbe, ahol fizethetsz a hitelkártyáddal.",
  "label.you_will_be_redirected_to_the_global_payments_wp": "Átirányítunk a GP Webpay Gateway rendszerbe, ahol fizethetsz a hitelkártyáddal.",
  "label.notification_praise_description": "{authorName} üzenetet küld a/z {activityCategoryName} tevékenységi naplóba:",
  "label.notification_message_description": "{authorName} üzenetet küld:",
  "notifications.offline_login": "Fél-offline üzemmódban veszel részt a programban",
  "tabs.badges": "Kitűzők",
  "errors.file_is_too_large": "Fájl maximális mérete 20MB",
  "moduleTitle.reactivate_account": "Fiók újraaktiválása",
  "route.reactivate_account": "Fiók újraaktiválása",
  "notifications.account_has_been_reactivated": "Fiók újraaktiválva",
  "label.personal_reflection": "A 'személyes gondolataid': írd le a gondolataidat és észrevételeidet a programmal kapcsolatos tapasztalataidról.",
  "label.terms_and_conditions": "Általános feltételek",
  "label.privacy_statements": "Adatvédelmi nyilatkozatok",
  "moduleTitle.guides_and_policies": "Útmutató és irányelvek",
  "btn.download_award_detail_summary": "Award adatok letöltése",
  "moduleTitle.forbidden": "Tilos",
  "label.select_your_sub_global_operating_partner": "Globális operátor partneri alegység kiválasztása",
  "label.select_your_global_operating_partner": "Globális operátor partner kiválasztása",
  "label.no_part_of_gop_or_not_sure": "Nem része globális operátor partnernek, bizonytalan vagyok ebben a kérdésben.",
  "moduleTitle.registration_not_exist": "Regisztáció nem található",
  "errors.al_must_be_older_than": "Award Líder nem lehet fiatalabb mint {years} év és {months} hónap.",
  "errors.date_last_log_cannot_be_in_future": "Legutolsó naplóbejegyzés nem lehet későbbi dátum.",
  "label.weeks_count": "Ismétlések",
  "moduleTitle.add_logs": "Adj hozzá bejegyzést",
  "button.bulk_logs": "Bejegyzések ömlesztve",
  "notifications.logs_has_been_added": "Bejegyzések hozzáadva",
  "label.cannot_signoff_until_16_yo": "Figyelem, az Awardod nem hagyható jóvá amíg be nem töltöd a 16 évet.",
  "label.aj_rejected_assessor_click": "Utazásod visszaküldte a kiértékelőd. Kattints",
  "label.activity_rejected_assessor_click": "Tevékenységed visszaküldte a kiértékelőd. Kattints",
  "notifications.activity_was_rejected": "Tevékenység elutasítva",
  "moduleTitle.reject_activity": "Tevékenységet elutasít",
  "label.team_goal": "Csapat célkitűzése",
  "title.insert_code_from_authenticator": "Hitelesítés kódja",
  "label.authenticator_app_code_desc": "Írj be 6 számjegyet",
  "route.mfa_authentication": "MFA hitelesítés",
  "moduleTitle.mfa_missing_code": "Valami hiba történt, kérjük, jelentkezzen be",
  "moduleTitle.mfa_scan_qr_title": "Nyisd meg a hitelesítőd",
  "label.mfa_scan_qr": "A Google Authenticator alkalmazást le kell töltenie az Apple Store / Google Play áruházból, mielőtt folytathatná. Miután letöltötte és telepítette, nyissa meg az alkalmazást, válassza a \"Kód hozzáadása\", majd a \"QR-kód beolvasása\" lehetőséget. Mutasson a telefonjával a QR-kódra, és párosítsa a telefonját az ORB-fiókkal. Amint megjelenik a hat számjegyű visszaszámlálás a mobiltelefonján, nyomja meg a \"Folytatás\" gombot ezen az oldalon a QR-kód alatt."
}